const companies = [
  {
    profileImageURL:
      "https://bookface-images.s3.amazonaws.com/small_logos/e9bc3a224a6ab03aa39009f5213c25815ae6a7d5.png",
    companyName: "Agave (W22)",
    roleName: "Founding Engineer (Senior)",
    location: "San Francisco, CA",
  },
  {
    profileImageURL:
      "https://bookface-images.s3.amazonaws.com/small_logos/3b36a43190da640752bb01710dff43f2c6e5ff91.png",
    companyName: "Orangewood Labs (W18)",
    roleName: "Industrial Robotics Engineer",
    location: "San Francisco, CA, US",
  },
  {
    profileImageURL:
      "https://bookface-images.s3.amazonaws.com/small_logos/cd298ab7cc0e50b44f16100129fb3d4a93dcabc0.png",
    companyName: "Generally Intelligent (S17)",
    roleName: "Systems Engineer",
    location: "San Francisco",
  },
  {
    profileImageURL:
      "https://bookface-images.s3.amazonaws.com/small_logos/5880942a2efc61218c66b07f0f2704038b3001e8.png",
    companyName: "ClassDojo (IK12)",
    roleName: "Sr. Fullstack Engineer",
    location: "San Francisco, CA, US",
  },
  {
    profileImageURL:
      "https://bookface-images.s3.amazonaws.com/small_logos/44c799568df44fb4f129df3ebec9417b8d588116.png",
    companyName: "Fieldguide (S20)",
    roleName: "Senior Machine Learning Engineer",
    location: "San Francisco, CA or Remote (USA) / Remote (US)",
  },
  {
    profileImageURL:
      "https://bookface-images.s3.amazonaws.com/small_logos/9e95c084b565d46c789767d2ecb4d17aca814585.png",
    companyName: "Mintlify (W22)",
    roleName: "Founding Engineer",
    location: "San Francisco, CA, US",
  },
  {
    profileImageURL:
      "https://bookface-images.s3.amazonaws.com/small_logos/60a8b4923dda092f9a2e9f1ffba7f2a5ce36777f.png",
    companyName: "Snippyly (W22)",
    roleName: "Founding Frontend Software Engineer (Web) (SF only)",
    location: "San Francisco, CA",
  },
  {
    profileImageURL:
      "https://bookface-images.s3.amazonaws.com/small_logos/711fea8d5911eff2cca6ae58f7c2371f123c9dc1.png",
    companyName: "Rescale (W12)",
    roleName: "Engineering Manager - Rescale",
    location: "San Francisco, CA, US / Draper, UT, US",
  },
  {
    profileImageURL:
      "https://bookface-images.s3.amazonaws.com/small_logos/bff84d941531b490bf65bb53c051ef24de72d746.png",
    companyName: "Fractional (W21)",
    roleName: "iOS Lead",
    location: "San Francisco, CA / New York, NY / Remote (US)",
  },
  {
    profileImageURL:
      "https://bookface-images.s3.amazonaws.com/small_logos/4cad69ca6c0d7b0893e00fda5e3fc74251d91fb9.png",
    companyName: "Truewind (W23)",
    roleName: "Founding Engineer",
    location: "San Francisco, CA, US",
  },
  {
    profileImageURL:
      "https://bookface-images.s3.amazonaws.com/small_logos/678a075ba845be1f92622449400b609811c48c31.png",
    companyName: "Aviator (S21)",
    roleName: "Software engineer, Founding team",
    location: "San Francisco, CA, US / Seattle, WA, US / Remote (US)",
  },
  {
    profileImageURL:
      "https://bookface-images.s3.amazonaws.com/small_logos/38b3a7de664099d22e91644d7e73f352ddc41038.png",
    companyName: "Latent (W23)",
    roleName: "Founding Engineer (Full Stack)",
    location: "San Francisco, CA, US",
  },
  {
    profileImageURL:
      "https://bookface-images.s3.amazonaws.com/small_logos/b247c36fd7cd016d5bb505d32429cd07b9acfcbb.png",
    companyName: "Sieve (W22)",
    roleName: "Distributed Systems Engineer (Backend)",
    location: "San Francisco, CA, US",
  },
  {
    profileImageURL:
      "https://bookface-images.s3.amazonaws.com/small_logos/2996d2661354e506266f6122ea522379aa429590.png",
    companyName: "Reach Labs (S15)",
    roleName: "Senior RF Systems Engineer",
    location: "Redwood City, CA",
  },
  {
    profileImageURL:
      "https://bookface-images.s3.amazonaws.com/small_logos/d77bd57cf941984bf1b8bd6d11e1a540ada0c7bc.png",
    companyName: "Seam (S20)",
    roleName: "Software Engineer",
    location: "San Francisco",
  },
  {
    profileImageURL:
      "https://bookface-images.s3.amazonaws.com/small_logos/25b0dd2e6d40928386efa49045651d24ad82e60b.png",
    companyName: "Motion (W20)",
    roleName: "Senior Software Engineer",
    location: "San Francisco/Remote / Remote (US)",
  },
  {
    profileImageURL:
      "https://bookface-images.s3.amazonaws.com/small_logos/76b4d06ff2e585b333f5f8c0fd3930367130db4e.png",
    companyName: "Questbook (W21)",
    roleName: "Software Engineer (Provider Engineering)",
    location: "Hyderabad, TG, IN / Seattle, WA, US / San Francisco, CA, US",
  },
  {
    profileImageURL:
      "https://bookface-images.s3.amazonaws.com/small_logos/de9cfc4baa1105e738c5fdd89eda874363283fed.png",
    companyName: "Slope (S21)",
    roleName: "Software Engineer (Backend) - All levels",
    location: "San Francisco, CA",
  },
  {
    profileImageURL:
      "https://bookface-images.s3.amazonaws.com/small_logos/64de74e1e5600c39e9d9edc099f75ed80a853079.png",
    companyName: "DreamWorld (W21)",
    roleName: "Internship: Software Engineer / Game Developer (Fall only)",
    location: "Redwood City, CA",
  },
];

export const ycCompanies = companies.sort(() => Math.random() - 0.5)